<template>
  <DraggableDialog
    :value="true"
    title="FAQ"
    subtitle="Perguntas frequentes"
    initialWidth="600"
    initialHeight="600"
    @close="close"
    @input="onInput"
  >
    <div class="pa-4">
      <v-expansion-panels accordion v-model="openedPanel">
        <v-expansion-panel
          v-for="(item, i) in faqItems"
          :key="i"
        >
          <v-expansion-panel-header class="font-weight-bold">
            {{ item.name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="pt-2" v-html="item.ajudaComplexo"></div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div v-if="faqItems.length === 0" class="text-center pa-4 grey--text">
        Nenhuma informação de ajuda disponível para os campos atuais.
      </div>
    </div>
  </DraggableDialog>
</template>

<script>
import DraggableDialog from "@/components/DraggableDialog.vue";

export default {
  name: 'FAQProjetos',
  props: {
    fields: {
      default: () => ({})
    },
    highlightKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      openedPanel: undefined
    }
  },
  components: {
    DraggableDialog
  },
  computed: {
    faqItems() {
      let allFields = [];
      
      if (this.fields) {
        Object.values(this.fields).forEach(group => {
           if (Array.isArray(group)) {
             allFields = [...allFields, ...group];
           } else if (typeof group === 'object' && group !== null) {
              allFields.push(group);
           }
        });
      }

      return allFields.filter(field => field.ajudaComplexo && field.ajudaComplexo.trim() !== '');
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onInput(val) {
      if (!val) this.close();
    },
    expandPanel() {
      if (this.highlightKey && this.faqItems.length > 0) {
        const index = this.faqItems.findIndex(item => item.key === this.highlightKey);
        if (index !== -1) {
          this.$nextTick(() => {
            this.openedPanel = index;
          });
        }
      }
    }
  },
  watch: {
    highlightKey: {
      handler: 'expandPanel',
      immediate: true
    },
    faqItems: {
      handler: 'expandPanel',
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-expansion-panel-content__wrap {
  padding-bottom: 16px;
}
</style>